import React, { useMemo, VFC } from 'react';
import { DataTable } from 'src/common/components/table/data-table';
import { generateColumn } from 'src/common/components/table/LegacyTable';
import { Workspace } from 'src/common/interfaces/workspace.interface';
import { DashboardSettingsManageWorkspacesActions } from './actions';
import { isTeamWorkspace, isPrivateWorkspace } from 'src/utils/journey';
import { formatNumber } from 'src/utils/text';

interface DashboardSettingsManageWorkspacesListProps {
  workspaces: Workspace[];
}

export const DashboardSettingsManageWorkspacesList: VFC<DashboardSettingsManageWorkspacesListProps> = ({
  workspaces,
}) => {
  const columns = useMemo(
    () => [
      generateColumn({
        Header: 'ID',
        accessor: 'id',
        width: 147,
        Cell: ({ index }: { index: number }) => (
          <span className='text-bedrock-p text-bedrock-black'>{workspaces[index].id}</span>
        ),
      }),
      generateColumn({
        Header: 'Name',
        accessor: 'name',
        width: 147,
        Cell: ({ index }: { index: number }) => (
          <span className='text-bedrock-p text-bedrock-black'>{workspaces[index].name}</span>
        ),
      }),
      generateColumn({
        Header: 'Members',
        accessor: '',
        width: 147,
        Cell: ({ index }: { index: number }) => (
          <span className='text-bedrock-p text-bedrock-black'>{formatNumber(workspaces[index].members.length)}</span>
        ),
      }),
      generateColumn({
        Header: '',
        accessor: 'actions',
        width: '100%',
        Cell: ({ index }: { index: number }) => (
          <DashboardSettingsManageWorkspacesActions
            isProtectedWorkspace={isTeamWorkspace(workspaces[index]) || isPrivateWorkspace(workspaces[index])}
            rowIndex={index}
          />
        ),
      }),
    ],
    [workspaces]
  );

  return (
    <div className='flex w-full mt-4'>
      <DataTable
        tableClassName='w-full'
        disableRowCursorPointer
        columns={columns}
        data={workspaces}
        columnClasses={['break-words', 'break-words']}
      />
    </div>
  );
};
